export default __webpack_public_path__ + "static/media/k_krawczyk.78bd89e2.png";